import { render, staticRenderFns } from "./ShopDoctorVideoTable.vue?vue&type=template&id=5655e309&"
import script from "./ShopDoctorVideoTable.vue?vue&type=script&lang=js&"
export * from "./ShopDoctorVideoTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopDoctorVideoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports